import axios from 'axios';
import { authHeader } from '../utils/tokenUtils';

const BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api`;

export const getReviewsByProduct = (productId) => axios.get(`${BASE_URL}/reviews/product/${productId}`);
export const getMyReviews = () => axios.get(`${BASE_URL}/reviews/my`, authHeader());
export const createReview = (formData) => axios.post(`${BASE_URL}/reviews`, formData, authHeader());
export const deleteReview = (reviewId) => axios.delete(`${BASE_URL}/reviews/${reviewId}`, authHeader());
export const getAllReviews = () => axios.get(`${BASE_URL}/reviews/admin`, authHeader());